import { render, staticRenderFns } from "./bigthings.vue?vue&type=template&id=0fbc4d36&scoped=true&"
import script from "./bigthings.vue?vue&type=script&lang=js&"
export * from "./bigthings.vue?vue&type=script&lang=js&"
import style0 from "./bigthings.vue?vue&type=style&index=0&id=0fbc4d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc4d36",
  null
  
)

export default component.exports